import type * as Types from 'app/types/graphql';

export type PromotionSelectFragment = Pick<
  Types.Promotion,
  | 'id'
  | 'name'
  | 'type'
  | 'priority'
  | 'discountAmount'
  | 'discountUnit'
  | 'conditions'
  | 'startDate'
  | 'endDate'
  | 'enableForAllPlans'
> & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> };

export type PromotionEdgeSelectFragment = Pick<Types.PromotionEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.Promotion,
      | 'id'
      | 'name'
      | 'type'
      | 'priority'
      | 'discountAmount'
      | 'discountUnit'
      | 'conditions'
      | 'startDate'
      | 'endDate'
      | 'enableForAllPlans'
    > & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> }
  >;
};

export const PromotionSelectFragmentDoc = `
    fragment PromotionSelect on Promotion {
  id
  name
  type
  priority
  discountAmount
  discountUnit
  conditions
  startDate
  endDate
  enableForAllPlans
  plans {
    id
    name
  }
}
    `;
export const PromotionEdgeSelectFragmentDoc = `
    fragment PromotionEdgeSelect on PromotionEdge {
  cursor
  node {
    ...PromotionSelect
  }
}
    `;
